import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { ifDefined } from "lit/directives/if-defined.js";

export const Template = ({ size, _slot }) => html`
    <ux-iws-sf-page-content size=${ifDefined(size)}>
        ${unsafeHTML(_slot)}
    </ux-iws-sf-page-content>
`;
